import React from 'react';
import '../styles/hero.css';
import Button from '../components/Button';
import { useTranslation } from 'react-i18next';

const Hero = ({ forFrontPage, title, desc, translation }) => {

    const { t } = useTranslation(translation);

    return (
        (forFrontPage ? (
            <section className='bl-hero'>
                <div className='hero-container'>
                    <div className='hero-content front'>
                        <h1 className='hero-title'>
                            {t('hero-title')}
                        </h1>
                        <div className='hero-descriptions'>
                            <p>
                                {t('hero-desc-1')}
                            </p>
                            <p>
                                {t('hero-desc-2')}
                            </p>
                            <p>
                                {t('hero-desc-3')}
                            </p>
                            <Button name={t('hero-btn-1')} url='/me'/>
                        </div>
                    </div>
                </div>
            </section>
        ) : (
            <section className='bl-hero'>
                <div className='hero-container'>
                    <div className='hero-content'>
                        <h1 className='hero-title'>
                            {t('hero-title')}
                        </h1>
                        <div className='hero-description'>
                            <p>
                                {t('hero-desc')}
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
        )
        
    );
};

export default Hero;
